// extracted by mini-css-extract-plugin
export var closed = "_ag-1";
export var resizer = "_ag-0";